import React from 'react';

function Header() {
  return (
    <header className="header">
      <h1>💪 운동 루틴 트래커</h1>
      <p>나만의 루틴을 추가하고 매일 완료 체크해요</p>
    </header>
  );
}

export default Header;
